<template lang="html">
  <section :id="id" class="add-customer-domain">
    <div class="domain-section">
      <span>{{ $t("name") }}:</span>
      <text-input
        class="text-input"
        :focus="true"
        @on-text-input-change="onInputChanged"
      />
    </div>
    <div class="domain-section">
      <toggle-button
        id="full-access"
        :label="$t('fullAccess')"
        :on="isFullAccess"
        @on-toggle-button-change="onToggleButtonChange"
      />
    </div>
    <div class="domain-section" v-show="!isFullAccess">
      <table class="m-table bordered-all no-row-hover striped">
        <thead>
          <tr>
            <th>{{ $t("customDisplayElement") }}</th>
            <th>{{ $t("access") }}</th>
          </tr>
        </thead>
        <tbody v-if="isReady">
          <custom-display-element-access-row
            v-for="(widget, index) in widgets"
            :key="index"
            :id="`custom-display-element-access-${widget.uuid}`"
            :customer="customerDomain"
            :uuid="uuid"
            :widget="widget"
          />
        </tbody>
      </table>
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME } from "@/static/global-variables";
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import TextInput from "@/components/TextInput";
  import ToggleButton from "@/components/ToggleButton";
  import CustomDisplayElementAccessRow from "@/components/custom-display-elements/tabs/customer-domains/CustomDisplayElementAccessRow";

  export default  {
    name: "add-customer-domain",
    components: {
      TextInput,
      ToggleButton,
      CustomDisplayElementAccessRow
    },
    props: {
      id: String,
      uuid: String,
      uuidAddNew: String
    },
    data() {
      return {
        isReady: false,
        customerDomain: {
          uuid: this.uuidAddNew,
          domain: "",
          fullAccess: true,
          widgetAccess: []
        }
      }
    },
    computed: {
      selectedAccess() {
        return this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAIN_WIDGET_ACCESS] || {};
      },
      customerAccess() {
        return {...this.selectedAccess[this.customerDomain.uuid] || {}};
      },
      distributionchannel() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNEL_LATEST_WIDGETS] || {};
      },
      widgets() {
        return distributionChannelUtil.removeWidgetsWithOnlyUnpublishedVersion(this.distributionchannel.widgets || []);
      },
      isFullAccess() {
        return this.customerDomain.fullAccess;
      }
    },
    watch: {
      customerAccess: {
        handler() {
          this.formatWidgetAccess();
        },
        deep: true
      }
    },
    mounted () {
      this.$store.commit(MUTATION_NAME.CUSTOMER_DOMAIN_DATA, this.customerDomain);
      this.isReady = true;
    },
    methods: {
      onInputChanged(domain) {
        this.customerDomain.domain = domain.trim();
      },
      onToggleButtonChange(fullAccess) {
        this.customerDomain.fullAccess = fullAccess;
        this.formatWidgetAccess();
      },
      formatWidgetAccess() {
        this.customerDomain.widgetAccess = distributionChannelUtil.formatWidgetAccess(this.isFullAccess, this.customerAccess);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .add-customer-domain {
    .domain-section {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-bottom: 1rem;
      .text-input {
        width: 100%;
        padding-right: 0;
      }
    }
  }
</style>
